// extracted by mini-css-extract-plugin
export default {"nav-list":"MainNavigation_nav-list__rXrhK","link":"MainNavigation_link__csOMz","current":"MainNavigation_current__yNGaK"};